import { call, put, all, fork, takeEvery } from 'redux-saga/effects'

import { notify } from 'reapop'
import i18n from 'i18next'
import { showLoading, hideLoading } from 'react-redux-loading-bar'

import AdvertisementsService from '../middlewares/advertisements'

import {
  GET_ADVERTISEMENTS_REQUEST,
  GET_ADVERTISEMENTS,
  GET_ADVERTISEMENT_REQUEST,
  GET_ADVERTISEMENT,
  CREATE_ADVERTISEMENT_REQUEST,
  CREATE_ADVERTISEMENT,
  UPDATE_ADVERTISEMENT_REQUEST,
  UPDATE_ADVERTISEMENT,
  DELETE_ADVERTISEMENT_REQUEST,
  DELETE_ADVERTISEMENT,
  GET_ADVERTISEMENTS_REQUEST_PENDING,
  GET_ADVERTISEMENTS_REQUEST_SUCCESS,
  GET_ADVERTISEMENTS_REQUEST_ERROR,
  CHANGE_ADVERTISEMENTS_REQUEST_PENDING,
  CHANGE_ADVERTISEMENTS_REQUEST_SUCCESS,
  CHANGE_ADVERTISEMENTS_REQUEST_ERROR,
} from '../types/advertisements'

function* getAdvertisementsWatcher() {
  yield takeEvery(GET_ADVERTISEMENTS_REQUEST, getAdvertisementsWorker)
}

function* getAdvertisementWatcher() {
  yield takeEvery(GET_ADVERTISEMENT_REQUEST, getAdvertisementWorker)
}

function* createAdvertisementWatcher() {
  yield takeEvery(CREATE_ADVERTISEMENT_REQUEST, createAdvertisementWorker)
}

function* updateAdvertisementWatcher() {
  yield takeEvery(UPDATE_ADVERTISEMENT_REQUEST, updateAdvertisementWorker)
}

function* deleteAdvertisementWatcher() {
  yield takeEvery(DELETE_ADVERTISEMENT_REQUEST, deleteAdvertisementWorker)
}

function* getAdvertisementsWorker({ payload }) {
  try {
    const params = payload || { page: 1, take: 100 }
    yield put(showLoading())
    yield put({ type: GET_ADVERTISEMENTS_REQUEST_PENDING })
    const response = yield call(AdvertisementsService.getAdvertisements, params)
    const { result } = response.data.data || { result: [] }
    yield put({ type: GET_ADVERTISEMENTS, payload: result })
    yield put({ type: GET_ADVERTISEMENTS_REQUEST_SUCCESS })
    yield put(hideLoading())
  } catch (error) {
    yield put({
      type: GET_ADVERTISEMENTS_REQUEST_ERROR,
      payload: error.response?.data?.messages || [error.message],
    })
    yield put(hideLoading())
  }
}

function* getAdvertisementWorker({ payload: { id } }) {
  try {
    yield put(showLoading())
    yield put({ type: GET_ADVERTISEMENTS_REQUEST_PENDING })
    const response = yield call(AdvertisementsService.getAdvertisementById, id)
    const advertisement = response.data.data
    yield put({ type: GET_ADVERTISEMENT, payload: advertisement })
    yield put({ type: GET_ADVERTISEMENTS_REQUEST_SUCCESS })
    yield put(hideLoading())
  } catch (error) {
    yield put({
      type: GET_ADVERTISEMENTS_REQUEST_ERROR,
      payload: error.response?.data?.messages || [error.message],
    })
    yield put(hideLoading())
  }
}

function* createAdvertisementWorker({ payload: { data, onSuccess } }) {
  try {
    yield put(showLoading())
    yield put({ type: CHANGE_ADVERTISEMENTS_REQUEST_PENDING })
    const response = yield call(AdvertisementsService.createAdvertisement, data)
    const advertisement = response.data.data
    yield put({ type: CREATE_ADVERTISEMENT, payload: advertisement })
    yield put({ type: CHANGE_ADVERTISEMENTS_REQUEST_SUCCESS })
    yield put(
      notify({
        title: i18n.t('notifs.created'),
        status: 'success',
        dismissAfter: 4000,
        allowHTML: true,
      }),
    )
    if (onSuccess) {
      onSuccess(advertisement)
    }
    yield put(hideLoading())
  } catch (error) {
    yield put({ type: CHANGE_ADVERTISEMENTS_REQUEST_ERROR, payload: error.response?.data?.messages || [error.message] })
    yield put(hideLoading())
  }
}

function* updateAdvertisementWorker({ payload: { id, data, onSuccess } }) {
  try {
    yield put(showLoading())
    yield put({ type: CHANGE_ADVERTISEMENTS_REQUEST_PENDING })
    const response = yield call(AdvertisementsService.updateAdvertisement, id, data)
    const advertisement = response.data.data
    yield put({ type: UPDATE_ADVERTISEMENT, payload: advertisement })
    yield put({ type: CHANGE_ADVERTISEMENTS_REQUEST_SUCCESS })
    yield put(
      notify({
        title: i18n.t('notifs.updated'),
        status: 'success',
        dismissAfter: 4000,
        allowHTML: true,
      }),
    )
    if (onSuccess) {
      onSuccess(advertisement)
    }
    yield put(hideLoading())
  } catch (error) {
    yield put({ type: CHANGE_ADVERTISEMENTS_REQUEST_ERROR, payload: error.response?.data?.messages || [error.message] })
    yield put(hideLoading())
  }
}

function* deleteAdvertisementWorker({ payload: { id, onSuccess } }) {
  try {
    yield put(showLoading())
    yield put({ type: CHANGE_ADVERTISEMENTS_REQUEST_PENDING })
    yield call(AdvertisementsService.deleteAdvertisement, id)
    yield put({ type: DELETE_ADVERTISEMENT, payload: id })
    yield put({ type: CHANGE_ADVERTISEMENTS_REQUEST_SUCCESS })
    yield put(
      notify({
        title: i18n.t('notifs.deleted'),
        status: 'success',
        dismissAfter: 4000,
        allowHTML: true,
      }),
    )
    if (onSuccess) {
      onSuccess()
    }
    yield put(hideLoading())
  } catch (error) {
    yield put({ type: CHANGE_ADVERTISEMENTS_REQUEST_ERROR, payload: error.response?.data?.messages || [error.message] })
    yield put(hideLoading())
  }
}

export default function* advertisements() {
  yield all([
    fork(getAdvertisementsWatcher),
    fork(getAdvertisementWatcher),
    fork(createAdvertisementWatcher),
    fork(updateAdvertisementWatcher),
    fork(deleteAdvertisementWatcher),
  ])
}
